import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

import { Page } from "@/components/Page";
import {
  ListIdContext,
  SubscriberListTable,
} from "@/components/SubscriberListTable";
import { H1 } from "@/components/ui/typography";
import { getSubscriberListQueryOptions } from "@/lib/api";

export const Route = createFileRoute(
  "/app/_sidebar-layout/subscriber-lists/$listId/view",
)({
  component: HomeComponent,
  loader: ({ context: { queryClient }, params: { listId } }) => {
    void queryClient.prefetchQuery(
      getSubscriberListQueryOptions(parseInt(listId)),
    );
  },
  head: () => ({ meta: [{ title: "Edit Subscriber List" }] }),
});

function HomeComponent() {
  const { listId } = Route.useParams();
  const { data: list } = useSuspenseQuery(
    getSubscriberListQueryOptions(parseInt(listId)),
  );

  return (
    <ListIdContext value={parseInt(listId)}>
      <Page className="md:gap-10">
        <H1>{list.display_name}</H1>
        <div className="flex flex-col gap-6">
          <SubscriberListTable users={list.subscribers} />
        </div>
      </Page>
    </ListIdContext>
  );
}
